import maintainfavorites from "./maintainfavorites";
import maintainaccesskeys from "./maintainaccesskeys";
import maintainpassword from "./maintainpassword";
import createpassword from "./createpassword";
import maintainpost from "./maintainpost";

export default {
  maintainfavorites,
  maintainaccesskeys,
  maintainpassword,
  createpassword,
  maintainpost,
};
